<template>
    <div class="card">
        <div class="card-header header-elements-inline bg-white py-2">
            <h5 class="card-title">
                <i v-if="loading" class="icon-spinner2 spinner mr-1"></i>
                <span v-else-if="todos.length > 0" class="badge badge-danger badgue-pill mr-1">{{ todos.length }}</span>
                <span v-else class="badge badge-light badge-pill mr-1">0</span>
                {{ title }}
            </h5>
            <div class="header-elements">
                <button type="button" @click="() => { visible = !visible; visible_manually = true; }" class="btn btn-secondary-100 text-secondary btn-icon">
                    <span v-if="visible"><i class="icon-arrow-down5"></i></span>
                    <span v-else><i class="icon-arrow-up5"></i></span>
                </button>
            </div>
        </div>
        <b-collapse id="todo-collapse-scanned_order_coupons" v-model="visible" class="mt-2">
            <div v-if="error" class="card-body">
                <div class="alert alert-danger mb-0">{{ error }}</div>
            </div>
            <div v-else>
                <rednax-datatable
                    :columns="tableColumns"
                    :data="todos"
                    @rowclick="rowClick"
                    no-wrapper
                >
                </rednax-datatable>
            </div>
        </b-collapse>

        <b-modal
            id="modal_show_coupon"
            title="Beställningstalong"
            size="full"
            @ok="redeemCard"
        >
            <div class="row" v-if="show_coupon">
                <div class="col-lg-8">
                    <image-viewer :image-src="show_coupon.url" v-model="coupon.rotate"></image-viewer>
                </div>
                <div class="col-lg-4">
<!--                    <div class="alert alert-info alert-styled-left">-->
<!--                        <div>1. Rotera bilden så den hamnar åt rätt håll.</div>-->
<!--                        <div>2. Mata in informationen</div>-->
<!--                        <div>3. Lös in kort</div>-->
<!--                    </div>-->
                    <div class="card bg-info-100 border-info">
                        <div class="card-header border-bottom border-bottom-info py-2">
                            <h6 class="card-title"><i class="icon-make-group mr-2"></i>Laxy AI</h6>
                        </div>
                        <div class="card-body pt-3">
                            <div id="typed_one"></div>
                            <div id="typed_two" class="mt-3"></div>
                        </div>
                    </div>
                    <ValidationObserver ref="couponform">
                        <input-with-validation
                            v-model="coupon.barcode"
                            rules="required"
                            name="barcode"
                            vid="coupon.barcode"
                            label="Kortnummer"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.name"
                            rules="required"
                            name="name"
                            vid="coupon.name"
                            label="Namn"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.address"
                            rules="required"
                            name="address"
                            vid="coupon.address"
                            label="Gatuadress"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.postal_code"
                            rules="required"
                            name="postal_code"
                            vid="coupon.postal_code"
                            label="Postnummer"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.city"
                            rules="required"
                            name="city"
                            vid="coupon.city"
                            label="Postort"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.door_code"
                            name="door_code"
                            vid="coupon.door_code"
                            label="Portkod"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.phone_number"
                            name="phone_number"
                            vid="coupon.phone_number"
                            label="Telefonnummer"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.email"
                            rules="email"
                            name="email"
                            vid="coupon.email"
                            label="E-postadress"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <input-with-validation
                            v-model="coupon.product_id"
                            rules="required|numeric"
                            name="product_id"
                            vid="coupon.product_id"
                            label="Produkt (ID)"
                            :disabled="read_loading || busy_saving"
                        ></input-with-validation>
                        <ValidationProvider tag="div" class="form-group" vid="coupon.wanted_delivery_date" name="Önskat leveransdatum" rules="required" v-slot="{ errors }">
                            <v-date-picker
                                v-model="coupon.wanted_delivery_date"
                                mode="date"
                                :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }"
                                show-iso-weeknumbers
                                :disabled-dates='{ weekdays: [1, 2, 3, 6] }'
                                :min-date='min_delivery_date'
                            >
                                <template v-slot="{ inputValue, togglePopover }">
                                    <label>Önskat leveransdatum<span class="text-danger">*</span></label>
                                    <div class="input-group">
                                        <input class="form-control" :value="inputValue" @focus="togglePopover()" :class="{ 'border-danger': !!(errors[0]) }">
                                        <span class="input-group-append">
                                            <button class="btn btn-light" type="button" @click="coupon.wanted_delivery_date = ''"><i class="icon-cross3"></i></button>
                                        </span>
                                    </div>
                                    <div class="text-muted">Välj en onsdag eller torsdag för mat, välj lördag för leverans ASAP.</div>
                                </template>
                            </v-date-picker>
                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="chk-want-info" v-model="coupon.want_info">
                            <label class="custom-control-label" for="chk-want-info">Vill ha info/nyhetsbrev</label>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
            <template #modal-footer="{ cancel, ok }">
                <button
                    type="button"
                    class="btn btn-light ml-auto"
                    @click="cancel"
                >
                    Avbryt
                </button>
                <limitless-button
                    ref="btnredeem"
                    type="button"
                    @click.prevent="ok"
                    :busy="busy_saving"
                    :disabled="read_loading || !(coupon.barcode)"
                >
                    Lös in kort
                </limitless-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import apiClient from '@services/ApiClient';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import Typed from 'typed.js';
import ImageViewer from '@components/ImageViewer.vue';
import getError from '@services/ErrorHelper';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';

export default {
    name: 'ScannedCouponsTable',
    components: {
        LimitlessButton,
        ImageViewer,
        VDatePicker,
        InputWithValidation,
        RednaxDatatable,
    },
    props: {
        title: {
            type: String,
        },
    },
    data() {
        return {
            loading: true,
            read_loading: false,
            busy_saving: false,
            visible: false,
            visible_manually: false,
            todos: [],
            error: '',
            show_coupon: null,
            coupon: {
                barcode: '',
                name: '',
                address: '',
                postal_code: '',
                city: '',
                door_code: '',
                phone_number: '',
                email: '',
                product_id: '',
                wanted_delivery_date: '',
                want_info: false,
                rotate: 0,
            },
            tableColumns: [
                {
                    data: 'filename',
                    header: 'File',
                },
                {
                    data: 'date',
                    header: 'Datum',
                },
            ],
            typed_two_sentences: ['Var god vänta...'],
            typed_one: null,
            typed_two: null,
        };
    },
    mounted() {
        this.getData();
        this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
            if (modalId === 'modal_show_coupon') {
                setTimeout(() => {
                    this.readCoupon(this.show_coupon.filename);
                }, 200);
                this.typed_one = new Typed('#typed_one', {
                    strings: ['Hej,<br>Det är jag som är Laxy, jag kommer att analysera beställningstalongen åt dig.'],
                    typeSpeed: 15,
                    loop: false,
                    showCursor: false,
                    onComplete: () => {
                        this.startTypedTwo();
                    },
                });
            }
        });
    },
    watch: {
        deliveryGroup() {
            this.todos = [];
            this.getData();
        },
        loading(val) {
            this.$emit('loaded', { loaded: !val, num_todos: this.todos.length, error: this.error });
        },
    },
    methods: {
        rowClick(row) {
            this.resetCoupon();
            this.show_coupon = row;
            this.$bvModal.show('modal_show_coupon');
        },
        resetCoupon() {
            this.coupon.barcode = '';
            this.coupon.name = '';
            this.coupon.address = '';
            this.coupon.postal_code = '';
            this.coupon.city = '';
            this.coupon.door_code = '';
            this.coupon.phone_number = '';
            this.coupon.email = '';
            this.coupon.product_id = '';
            this.coupon.wanted_delivery_date = '';
            this.coupon.want_info = false;
            this.coupon.rotate = 0;
        },
        getData() {
            this.loading = true;
            apiClient.get('/vue/prodorders/todo', {
                params: {
                    type: 'scanned_order_coupons',
                },
            }).then((response) => {
                this.error = '';
                this.todos = response.data.data;
                if (this.visible_manually === false) {
                    if (response.data.data.length > 0) {
                        this.visible = true;
                    } else {
                        this.visible = false;
                    }
                }
            }).catch((error) => {
                this.todos = [];
                if (error.response && error.response.message) {
                    this.error = error.response.message;
                } else {
                    this.error = 'Något gick fel när data skulle hämtas...';
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        async redeemCard(event) {
            event.preventDefault();
            const isValid = await this.$refs.couponform.validate();
            if (isValid) {
                this.busy_saving = true;
                apiClient.post('/vue/prodorders/coupon/redeem', { filename: this.show_coupon.filename, coupon: this.coupon }).then((response) => {
                    this.$refs.btnredeem.triggerSaved();
                    this.$router.push({ name: 'prodorders.edit', params: { id: response.data.ProdOrderID } });
                }).catch((error) => {
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.couponform.setErrors(parsederror);
                    }
                    this.$refs.btnredeem.triggerFailed();
                }).finally(() => {
                    this.busy_saving = false;
                });
            } else {
                this.$refs.btnrecipientform.triggerFailed();
            }
        },
        readCoupon(filename) {
            this.typed_two_sentences = ['Var god vänta...', 'Jag är snart klar...', 'Behöver bara en liten stund till...', 'Snart så...'];
            if (this.typed_two) {
                this.typed_two.destroy();
                this.typed_two = null;
            }
            this.read_loading = true;
            apiClient.get('/vue/prodorders/coupon/read/' + filename)
                .then((response) => {
                    Object.entries(response.data).forEach(([key, val]) => {
                        if (key in this.coupon) {
                            this.coupon[key] = val;
                        }
                    });
                    this.typed_two_sentences = ['Sådär nu är jag klar, kontrollera att informationen stämmer! Ibland kan jag råka missa någon siffra eller bokstav..'];
                    if (this.typed_two) {
                        this.typed_two.destroy();
                        this.typed_two_sentences = ['Sådär nu är jag klar, kontrollera att informationen stämmer! Ibland kan jag råka missa någon siffra eller bokstav..'];
                        this.startTypedTwo();
                    }
                }).catch(() => {
                    this.typed_two_sentences = [
                        'Ojdå... Tyvärr kan jag inte hjälpa dig för tillfället. Gär istället sä här:<br><br>'
                        + '1. Rotera bilden så den hamnar åt rätt håll.<br>'
                        + '2. Mata in informationen<br>'
                        + '3. Lös in kort',
                    ];
                    if (this.typed_two) {
                        this.typed_two.destroy();
                        this.typed_two_sentences = [
                            'Ojdå... Tyvärr kan jag inte hjälpa dig för tillfället. Gär istället sä här:<br><br>'
                            + '1. Rotera bilden så den hamnar åt rätt håll.<br>'
                            + '2. Mata in informationen<br>'
                            + '3. Lös in kort',
                        ];
                        this.startTypedTwo();
                    }
                }).finally(() => {
                    this.read_loading = false;
                });
        },
        startTypedTwo() {
            this.typed_two = new Typed('#typed_two', {
                strings: [...this.typed_two_sentences],
                typeSpeed: 15,
                loop: false,
                showCursor: false,
                backDelay: 2000,
            });
        },
    },
    computed: {
        min_delivery_date() {
            const date = new Date();
            if (date.getDay() !== 1 || (date.getDay() === 1 && date.getHours() >= 14)) {
                date.setDate(date.getDate() + (((1 + 7 - date.getDay()) % 7) || 7));
            }
            return date;
        },
    },
};
</script>
